<template>
  <div id="infoc">
    <section class="mi-wrap">
      <div class="mi-card">

        <!-- 헤더 -->
        <header class="mi-head">
          <div class="mi-avatar">{{ (userInfo.uNickName || '회').charAt(0) }}</div>
          <div class="mi-head-txt">
            <h3>회원정보 수정</h3>
            <p>
              <span class="mi-name">{{ userInfo.uNickName }}</span>님
              <span class="mi-chip">{{ ({ K: '카카오 간편가입', N: '네이버 간편가입', E: '직접가입', H: '직접가입', M: '앱가입' })[userInfo.joinFlag] || '회원' }}</span>
            </p>
          </div>
        </header>

        <div class="mi-body">

          <!-- 간편가입 안내 -->
          <div class="mi-notice" v-if="userInfo.joinFlag && !canEdit">
            <i class="bi bi-info-circle"></i>
            카카오·네이버 간편가입 회원은 비밀번호·이름·연락처를 이곳에서 수정할 수 없어요.
          </div>

          <!-- ① 계정 정보 -->
          <div class="mi-section">
            <div class="sec-title"><span class="sec-no">1</span>계정 정보</div>

            <div class="form-floating">
              <input type="email" class="form-control" id="miEmail" placeholder="name@example.com" v-model="userInfo.uEmail" disabled>
              <label for="miEmail">아이디 (변경불가)</label>
            </div>

            <template v-if="canEdit">
              <div class="form-floating">
                <input type="password" class="form-control" id="inputPassword" placeholder="새 비밀번호" maxlength="12" autocomplete="new-password"
                  v-model="newPass" ref="uPass">
                <label for="inputPassword">새 비밀번호 (영문+숫자, 5~12자리)</label>
              </div>
              <div class="form-floating">
                <input type="password" class="form-control" id="inputPassword2" placeholder="새 비밀번호 확인" maxlength="12" autocomplete="new-password"
                  v-model="newPass2" ref="uPass2">
                <label for="inputPassword2">새 비밀번호 확인</label>
              </div>
              <p class="hint">비밀번호를 바꿀 때만 입력하세요. 비워두면 기존 비밀번호가 유지됩니다.</p>
            </template>
            <div class="form-floating" v-else>
              <input type="password" class="form-control" id="inputPassword" placeholder="비밀번호" disabled>
              <label for="inputPassword">비밀번호 (간편가입 회원은 변경불가)</label>
            </div>
          </div>

          <!-- ② 회원 정보 -->
          <div class="mi-section">
            <div class="sec-title"><span class="sec-no">2</span>회원 정보</div>

            <div class="form-floating">
              <input type="text" class="form-control" id="miNickName" placeholder="한글이름" maxlength="50"
                v-model="userInfo.uNickName" ref="uNickName" :disabled="!canEdit">
              <label for="miNickName">한국명 <span class="req">필수</span></label>
            </div>

            <div class="form-floating">
              <input type="text" inputmode="numeric" class="form-control" id="miPhone" placeholder="휴대폰번호" maxlength="20"
                v-model="userInfo.alimCallC" ref="alimCallC" :disabled="!canEdit">
              <label for="miPhone">휴대전화번호 ('-' 제외) <span class="req">필수</span></label>
            </div>
          </div>

          <!-- ③ 여권 정보 -->
          <div class="mi-section">
            <div class="sec-title"><span class="sec-no">3</span>여권 정보 <span class="opt">선택</span></div>
            <p class="sec-desc">미리 등록해두시면 예약·멤버십 가입 시 다시 입력하지 않아도 돼요.</p>

            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="miEngName" placeholder="영문명" maxlength="40" v-model="userInfo.engName">
              <label for="miEngName">영문명 (여권과 동일하게)</label>
            </div>

            <div class="row-2">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="miPassport" placeholder="여권번호" maxlength="40" v-model="userInfo.uPassport">
                <label for="miPassport">여권번호</label>
              </div>
              <div class="form-floating">
                <input type="date" class="form-control" id="miPassportExp" v-model="userInfo.uPassportExp">
                <label for="miPassportExp">여권 만료일</label>
              </div>
            </div>
          </div>

          <!-- ④ 동의 -->
          <div class="mi-section">
            <div class="sec-title"><span class="sec-no">4</span>개인정보 동의</div>

            <div class="agree-list">
              <label class="agree-row" :class="{ on: confirm_Privacy === 'Y' }" for="fAgree">
                <span class="agree-txt"><span class="req">필수</span>개인정보 수집 및 이용 동의</span>
                <span class="form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="fAgree" v-model="confirm_Privacy" ref="confirm_Privacy" true-value="Y" false-value="N">
                </span>
              </label>
            </div>
          </div>

          <!-- 버튼 -->
          <div class="mi-actions">
            <button class="btn-cancel" @click="goToMypage()"><i class="bi bi-chevron-left"></i> 마이페이지</button>
            <button class="btn-go" @click="updateMyInfo" :disabled="saving">
              <span v-if="saving" class="spinner-border spinner-border-sm me-2" role="status"></span>{{ saving ? '저장중...' : '저장하기' }}
            </button>
          </div>

          <p class="mi-out">
            <a href="javascript:void(0)" @click="memWithdrawal">회원탈퇴</a>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';

// 비밀번호·이름·연락처를 직접 수정할 수 있는 가입유형 (E:홈페이지 직가입, H:수동가입, M:앱 직가입)
// K(카카오)/N(네이버) 간편가입은 수정 불가
const EDITABLE_JOIN_FLAGS = ["E", "H", "M"];

export default {
  data() {
    return {
      userInfo: {},               // 회원정보 (비밀번호는 담지 않음)
      newPass: "",                // 새 비밀번호 (비우면 변경 안 함)
      newPass2: "",               // 새 비밀번호 확인
      confirm_Privacy: "",        // [필수] 개인정보 수집·이용 동의
      saving: false,              // 저장 중복클릭 방지
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    canEdit() {
      return EDITABLE_JOIN_FLAGS.includes(this.userInfo.joinFlag);
    },
  },

  async mounted() {
    // 비회원 접근 차단 (조회보다 먼저)
    if (!this.user || !this.user.email) {
      this.$swal.fire("", "로그인 후 이용해주세요.", "warning");
      this.$router.push({ path: "/" });
      return;
    }
    await this.getUserInfo();
  },

  methods: {
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    goToMypage() {
      this.$router.push({ path: "/myPage" });
    },
    goToHome() {
      this.$router.push({ path: "/" });
    },

    warn(ref, msg) {
      const el = this.$refs[ref];
      if (el && el.focus) el.focus();
      this.$swal.fire("", msg, "warning");
      return false;
    },

    /* ---------- 회원정보 조회 ---------- */
    async getUserInfo() {
      const rows = await this.$api("/api/selMyInfo", { param: [this.user.email] });   // uPass 를 조회하지 않는 전용 쿼리
      if (!Array.isArray(rows) || rows.length === 0) {
        this.$swal.fire("", "회원정보를 불러오지 못했습니다. 다시 시도해주세요.", "error");
        return;
      }

      const info = { ...rows[0] };
      delete info.uPass;   // 혹시 포함돼 와도 화면에 보관하지 않음
      // selMyInfo 가 'YYYY-MM-DD' 문자열(또는 NULL)로 내려줌
      info.uPassportExp = info.uPassportExp && info.uPassportExp > "1800-01-01" ? info.uPassportExp : "";
      this.userInfo = info;
    },

    /* ---------- 저장 ---------- */
    validate() {
      const u = this.userInfo;

      if (!u.uEmail) {
        this.$swal.fire("", "회원정보를 다시 불러와 주세요.", "warning");
        return false;
      }

      if (this.canEdit) {
        // 새 비밀번호: 입력한 경우에만 검사
        if (this.newPass || this.newPass2) {
          const p = this.newPass;
          if (p.length < 5) return this.warn("uPass", "비밀번호는 5자리 이상이어야 합니다");
          if (!/[a-zA-Z]/.test(p) || !/\d/.test(p)) return this.warn("uPass", "비밀번호는 숫자와 문자로 구성되어야 합니다.");
          if (p !== this.newPass2) return this.warn("uPass2", "새 비밀번호가 일치하지 않습니다.");
        }

        if (!u.uNickName || !u.uNickName.trim()) return this.warn("uNickName", "한국명을 입력하세요");

        const tel = String(u.alimCallC || "").replace(/[^0-9]/g, "");
        if (!tel) return this.warn("alimCallC", "연락처를 입력하세요");
        if (!/^010\d{7,8}$/.test(tel)) return this.warn("alimCallC", "유효한 전화번호가 아닙니다.");
        u.alimCallC = tel;
        u.uNickName = u.uNickName.trim();
      }

      if (this.confirm_Privacy !== "Y") return this.warn("confirm_Privacy", "개인정보 수집 및 이용에 동의해 주세요");
      return true;
    },

    async updateMyInfo() {
      if (this.saving || !this.validate()) return;
      this.saving = true;

      try {
        const u = this.userInfo;
        const engName = (u.engName || "").trim().toUpperCase();
        const passport = (u.uPassport || "").replace(/\s/g, "").toUpperCase();
        const passportExp = u.uPassportExp || null;

        // 1) 기본정보 (이름 포함, 비밀번호 제외)
        const res = await this.$api("/api/upd_MyInfo_v2", {
          param: [u.uNickName, u.alimCallC, u.alimCallC, engName, passport, passportExp, u.uEmail],   // uNickName, alimCallC, uPhone, engName, uPassport, uPassportExp, WHERE uEmail
        });
        if (!res || res.error) {
          console.error("upd_MyInfo_v2", res && res.error);
          this.$swal.fire("", "업데이트 중 오류가 발생했습니다.<br>다시 진행해 주세요.", "warning");
          return;
        }

        // 2) 비밀번호 (새로 입력한 경우만)
        if (this.canEdit && this.newPass) {
          const pw = await this.$api("/api/upd_MyPass", { param: [this.newPass, u.uEmail] });
          if (!pw || pw.error) {
            console.error("upd_MyPass", pw && pw.error);
            this.$swal.fire("", "회원정보는 저장되었으나 비밀번호 변경에 실패했습니다.<br>다시 시도해 주세요.", "warning");
            return;
          }
        }

        await this.$swal.fire("", "회원정보가 저장되었습니다", "success");
        location.reload();
      } finally {
        this.saving = false;
      }
    },

    /* ---------- 회원탈퇴 ---------- */
    async memWithdrawal() {
      const mId = this.userInfo.uEmail;
      if (!mId) return;

      const result = await this.$swal.fire({
        title: "회원탈퇴를 진행하시겠습니까?",
        html: "※ 탈퇴와 동시에 포인트, 멤버십 정보는 즉시 삭제됩니다.<br>회원복구는 <b class='text-danger'>불가능</b>한 점 양지하여 주십시오.",
        showCancelButton: true,
        confirmButtonText: "탈퇴합니다",
        cancelButtonText: "취소합니다",
        confirmButtonColor: "#e5484d",
      });
      if (!result.isConfirmed) return;

      // 탈퇴 전에 알림톡용 정보 보관 (탈퇴 후에는 DB 조회 불가)
      const member = { name: this.userInfo.uNickName, email: mId, tel: this.userInfo.alimCallC };

      const res = await this.$api("/api/proc_memberWithdrawal", { param: [mId] });
      if (!res || res.error) {
        const msg = res && res.error && (res.error.sqlMessage || res.error.message);
        this.$swal.fire("", "회원탈퇴 중 오류가 발생했습니다" + (msg ? "(" + msg + ")" : ""), "error");
        return;
      }

      // 알림톡 → 안내 → 로그아웃 순서 (로그아웃이 페이지를 이동시키므로 맨 마지막)
      await this.sendWithdrawalKakao(member);
      await this.$swal.fire("", "회원탈퇴와 회원정보삭제가 완료되었습니다.<br>그 동안 감사했습니다.", "info");
      this.toB2CLogout();
    },

    async sendWithdrawalKakao(member) {
      try {
        // 다른 화면들과 동일한 순서: [이메일, 알림유형, 연락처]
        const hist = await this.$api("/api/insKSendHistory", { param: [member.email, "WT", member.tel] });
        if (!hist || !(hist.affectedRows > 0)) return;

        await this.$api("api/kakaoAlimSend5", {
          param: [{
            kakaoAlimData: {
              clientName: member.name,
              memberName: member.name,
              memberId: member.email,
              withdrwalDate: moment().format("YYYY-MM-DD"),
              resPhone: member.tel,
              resCode: member.email,
              clientCall: member.tel,
              alimFlag: "WT",
            },
          }],
        });
      } catch (e) {
        console.error("탈퇴 알림톡 발송 실패", e);   // 알림톡 실패가 탈퇴 흐름을 막지 않도록
      }
    },

    // 카카오 토큰이 없으면(네이버/직접가입) 콜백이 오지 않으므로 바로 정리
    toB2CLogout() {
      const cleanup = () => {
        this.$store.commit("user", {});
        window.sessionStorage.clear();
        window.localStorage.clear();
        location.href = "/";
      };

      if (window.Kakao && window.Kakao.Auth && window.Kakao.Auth.getAccessToken && window.Kakao.Auth.getAccessToken()) {
        window.Kakao.Auth.logout(() => cleanup());
      } else {
        cleanup();
      }
    },
  },
};
</script>

<style scoped>
/* =========================================================
 * 브랜드 컬러 — 회원가입·멤버십 가입 페이지와 동일
 * ========================================================= */
#infoc {
  --brand:      #0e5e5e;
  --brand-dark: #092525;
  --brand-soft: #e8f3f2;
  --accent:     #c9a227;
  --danger:     #e5484d;
  --text:       #1f2a2a;
  --muted:      #7b8a8a;
  --line:       #dfe7e6;
  --radius:     12px;
}

/* ---------- 레이아웃 ---------- */
#infoc {
  padding: 4rem 1rem 5rem;
  background:
    radial-gradient(1200px 400px at 50% -120px, var(--brand-soft), transparent 70%),
    #f7faf9;
  color: var(--text);
}
#infoc .mi-wrap { display: flex; justify-content: center; }
#infoc .mi-card {
  width: 100%;
  max-width: 620px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(9, 37, 37, .08), 0 2px 6px rgba(9, 37, 37, .04);
  overflow: hidden;
}

/* ---------- 헤더 ---------- */
#infoc .mi-head {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.8rem 2rem;
  color: #fff;
  background: linear-gradient(135deg, var(--brand-dark) 0%, var(--brand) 100%);
}
#infoc .mi-avatar {
  flex: 0 0 auto;
  width: 56px; height: 56px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--brand-dark);
  background: linear-gradient(135deg, #f3e2a6 0%, var(--accent) 100%);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, .25);
}
#infoc .mi-head h3 { font-size: 1.4rem; font-weight: 700; margin: 0 0 .25rem; color: #fff; }
#infoc .mi-head p { margin: 0; font-size: .9rem; opacity: .9; display: flex; align-items: center; flex-wrap: wrap; gap: .3rem; }
#infoc .mi-name { font-weight: 700; }
#infoc .mi-chip {
  margin-left: .4rem;
  font-size: .72rem;
  font-weight: 600;
  padding: .12rem .6rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, .15);
  border: 1px solid rgba(255, 255, 255, .3);
}

#infoc .mi-body { padding: 1.8rem 2rem 1.6rem; }

/* 간편가입 안내 */
#infoc .mi-notice {
  display: flex; gap: .5rem; align-items: flex-start;
  font-size: .82rem;
  color: #6b5a12;
  background: #fbf5e1;
  border: 1px solid #f0e3b3;
  border-radius: var(--radius);
  padding: .75rem 1rem;
  margin-bottom: 1.6rem;
}
#infoc .mi-notice i { color: var(--accent); margin-top: .1rem; }

/* ---------- 섹션 ---------- */
#infoc .mi-section { margin-bottom: 1.8rem; }
#infoc .sec-title {
  display: flex; align-items: center; gap: .55rem;
  font-weight: 700; font-size: 1rem;
  color: var(--brand-dark);
  margin-bottom: .8rem;
}
#infoc .sec-no {
  width: 22px; height: 22px;
  display: inline-flex; align-items: center; justify-content: center;
  border-radius: 50%;
  background: var(--brand);
  color: #fff;
  font-size: .75rem;
}
#infoc .sec-desc { font-size: .8rem; color: var(--muted); margin: -.3rem 0 .8rem; }
#infoc .req, #infoc .opt {
  font-size: .66rem; font-weight: 700;
  border-radius: 4px; padding: .05rem .38rem;
  margin-left: .2rem;
  vertical-align: middle;
}
#infoc .req { color: var(--danger); background: #fdecec; }
#infoc .opt { color: var(--muted); background: #eef2f2; }

/* ---------- 입력 ---------- */
#infoc .form-floating { margin-bottom: .7rem; }
#infoc .form-control {
  border: 1.5px solid var(--line);
  border-radius: var(--radius);
  color: var(--text);
  transition: border-color .2s, box-shadow .2s;
}
#infoc .form-control:focus { border-color: var(--brand); box-shadow: 0 0 0 4px rgba(14, 94, 94, .12); }
#infoc .form-control:disabled { background-color: #f4f7f7; color: #5d6b6b; }
#infoc .form-floating > label { color: var(--muted); }
#infoc .form-floating > .form-control:focus ~ label { color: var(--brand); }

#infoc .row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: .6rem; }
#infoc .row-2 .form-floating { margin-bottom: .7rem; }

/* ---------- 동의 (스위치) ---------- */
#infoc .agree-list {
  border: 1.5px solid var(--line);
  border-radius: var(--radius);
  overflow: hidden;
}
#infoc .agree-row {
  display: flex; align-items: center; justify-content: space-between;
  gap: 1rem;
  margin: 0;
  padding: .9rem 1.1rem;
  font-size: .92rem;
  cursor: pointer;
  transition: background-color .2s;
}
#infoc .agree-row + .agree-row { border-top: 1px solid var(--line); }
#infoc .agree-row.on { background: var(--brand-soft); }
#infoc .agree-txt .req, #infoc .agree-txt .opt { margin: 0 .45rem 0 0; }
#infoc .form-switch { padding: 0; margin: 0; }
#infoc .form-switch .form-check-input {
  width: 2.6em; height: 1.4em;
  margin: 0;
  cursor: pointer;
  border-color: #c3cfce;
}
#infoc .form-check-input:checked { background-color: var(--brand); border-color: var(--brand); }
#infoc .form-check-input:focus { box-shadow: 0 0 0 3px rgba(14, 94, 94, .15); border-color: var(--brand); }

/* ---------- 버튼 ---------- */
#infoc .mi-actions { display: flex; gap: .6rem; margin-top: .4rem; }
#infoc .btn-cancel {
  flex: 0 0 34%;
  border: 1.5px solid var(--line);
  border-radius: 14px;
  background: #fff;
  color: var(--muted);
  font-weight: 600;
  padding: 1rem 0;
  transition: border-color .2s, color .2s;
}
#infoc .btn-cancel:hover { border-color: var(--muted); color: var(--text); }
#infoc .btn-go {
  flex: 1;
  border: none;
  border-radius: 14px;
  padding: 1rem 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
  box-shadow: 0 8px 20px rgba(14, 94, 94, .25);
  transition: transform .15s;
}
#infoc .btn-go:hover:not(:disabled) { transform: translateY(-1px); }
#infoc .btn-go:disabled { opacity: .6; }
#infoc .hint { font-size: .78rem; color: var(--muted); margin: -.3rem 0 .2rem .25rem; }

#infoc .mi-out { text-align: center; margin: 1.6rem 0 0; }
#infoc .mi-out a { font-size: .78rem; color: #a7b3b2; text-decoration: underline; }
#infoc .mi-out a:hover { color: var(--danger); }

/* ---------- 모바일 ---------- */
@media (max-width: 575px) {
  #infoc { padding: 1.5rem .75rem 3rem; }
  #infoc .mi-card { border-radius: 16px; }
  #infoc .mi-head { padding: 1.4rem 1.2rem; }
  #infoc .mi-avatar { width: 48px; height: 48px; font-size: 1.2rem; }
  #infoc .mi-head h3 { font-size: 1.25rem; }
  #infoc .mi-body { padding: 1.4rem 1.1rem 1.4rem; }
  #infoc .row-2 { grid-template-columns: 1fr; gap: 0; }
}
</style>